import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ReactRouterPropTypes from "react-router-prop-types";

import { GroupShape, UserShape } from "../../policies/proptypes";
import groups from "../../policies/selectors/groups";
import Entity from "../../shared/components/Entity";
import VirtualizedTable from "../../shared/components/VirtualizedTable";
import { MIN_WIDTH_ENTITIES } from "../../shared/constants";
import { getModalBasePath } from "../../shared/utils";

class UserDetails extends Component {
  cellRenderer = (_, group) => {
    if (!group) {
      return null;
    }
    const { name } = group;
    const { location } = this.props;

    return (
      <div className="p-table__cell">
        <Link
          className="u-hide-text-overflow"
          to={`${getModalBasePath(location)}/${name}`}
        >
          <Entity type="group">{name}</Entity>
        </Link>
      </div>
    );
  };

  headerRenderer = column => (
    <div className="p-table__header-cell--muted">{column.label}</div>
  );

  render = () => {
    const { groups, user } = this.props;
    const columns = [
      { key: "name", label: "Groups", minWidth: MIN_WIDTH_ENTITIES }
    ];

    return (
      <Fragment>
        <div style={{ gridArea: "entity-details" }}>
          <div className="l-groups__details">
            <div className="l-groups__column" style={{ flex: "1" }}>
              <div className="l-groups__column-header">
                <span className="p-muted-heading u-no-margin--bottom">
                  Username
                </span>
              </div>
              <div className="l-groups__column-panel">
                {user.username || "N/A"}
              </div>
            </div>
            <div className="l-groups__column" style={{ flex: "1" }}>
              <div className="l-groups__column-header">
                <span className="p-muted-heading u-no-margin--bottom">
                  Name
                </span>
              </div>
              <div className="l-groups__column-panel">{user.name || "N/A"}</div>
            </div>
            <div className="l-groups__column" style={{ flex: "1" }}>
              <div className="l-groups__column-header">
                <span className="p-muted-heading u-no-margin--bottom">
                  Email address
                </span>
              </div>
              <div className="l-groups__column-panel">
                {user.email || "N/A"}
              </div>
            </div>
          </div>
        </div>
        <div
          className="l-groups__table-container"
          style={{ gridArea: "entities-related" }}
        >
          <VirtualizedTable
            columns={columns}
            rows={groups}
            cellRenderer={this.cellRenderer}
            headerRenderer={this.headerRenderer}
          />
        </div>
      </Fragment>
    );
  };
}

UserDetails.propTypes = {
  groups: PropTypes.arrayOf(GroupShape).isRequired,
  user: UserShape.isRequired,
  location: ReactRouterPropTypes.location.isRequired
};

const mapStateToProps = (state, props) => ({
  groups: groups.getByUser(state, props.user),
  location: state.router.location
});

export default connect(mapStateToProps)(UserDetails);
